import type { EventRow, TicketTypeRow } from "@/hooks/platform/useEvents";

export type EventTimeFilter = "all" | "current" | "live";

// Without an end time, only the event's calendar day can be identified as current.
export function eventIsCurrent(event: Pick<EventRow, "event_date" | "end_date">, now = new Date()): boolean {
  const start = new Date(event.event_date);
  const end = event.end_date ? new Date(event.end_date) : new Date(start);
  if (!event.end_date) end.setHours(23, 59, 59, 999);
  return start <= now && now <= end;
}

// "Live" means the scheduled event is underway, not a verified livestream.
export function eventIsLive(event: Pick<EventRow, "event_date" | "end_date">, now = new Date()): boolean {
  return !!event.end_date && eventIsCurrent(event, now);
}

export function eventCreatorCount(lineup: EventRow["lineup"]): number {
  if (!Array.isArray(lineup)) return 0;
  return new Set(lineup.flatMap((slot) => {
    if (!slot || typeof slot !== "object" || Array.isArray(slot)) return [];
    const id = (slot as Record<string, unknown>).id;
    return typeof id === "string" && id ? [id] : [];
  })).size;
}

export function eventTicketEntries(types: Pick<TicketTypeRow, "quantity_sold" | "admits_per_ticket">[]): number {
  return types.reduce((sum, tier) => sum + tier.quantity_sold * Math.max(1, tier.admits_per_ticket), 0);
}